<template>
	<div class="update-container">
		<navBarNoLab :onIndex="100"></navBarNoLab> 
		<!-- 背景部分 -->
		<updateBack :backGroundCom="backGroundComInfo">
			<template #navList>
				<pageElement :onIndex="100" />
			</template>
		</updateBack>
		<!-- tabs切换部分 -->
		<updateTabs />
		<bottomWidge />
	</div>
</template>

<script>
	import navBarNoLab from "@/views/components/navBarNoLab"
	// 背景部分
	import updateBack from "./components/updateBack"
	// tabs部分
	import updateTabs from "./components/updateTabs"
	// 底部
	import bottomWidge from "@/views/components/bottomWidge"
	import pageElement from "../common/pageElement"

	export default {
		components: {
			navBarNoLab,
			updateBack,
			updateTabs,
			bottomWidge,
			pageElement
		},
		data () {
			return {
				backGroundComInfo: {
					title1: "项目库正在全速前进， 编程学科上线项目已达40+",
					title: '每天都在进步'
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.update-container {
		width: 100%;
		min-width: 1200px;
		background-color: #fff;
		height: auto;
	}
</style>